module.exports = __webpack_public_path__ + "img/product6@2x.181d31b7.png";